import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { ROUTES } from '#/config/routes';
import { fetchStockReturnDetail } from '#/api/imsMgmt/receipts/stockReturn/fetchDetail';
import { Button } from '#/modules/commonComponents/button';
import { cn } from '#/lib/utils';
import PageShell from '#/modules/infra/layout/PageShell';
import StockReturnBlock from '#/modules/imsMgmt/receipts/stockReturn/components/StockReturnBlock';
import { getStockReturnApiErrorMessage } from '#/modules/imsMgmt/receipts/stockReturn/helper/apiError';
import { stockReturnDetailQueryKey } from '#/utils/queryKeys';

const StockReturnDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: stockReturnDetailQueryKey(id),
    queryFn: () => fetchStockReturnDetail(id),
    enabled: Boolean(id),
  });

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">退料單詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.workOrderReturn}>返回列表</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getStockReturnApiErrorMessage(detailQuery.error, '載入退料單失敗')}
            </p>
          ) : null}

          {detail ? (
            <StockReturnBlock
              detail={detail}
              defaultOpen
              showActions
              onRefetch={() => detailQuery.refetch()}
            />
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default StockReturnDetailPage;
